import Goal from "../goal"
import {WorkdayStretchType} from "../../../gd/workday/workday"

const debug = false
// const debug = 'setGoalDuration'

export default function setGoalDuration(goal: Goal, value: number | null, type: WorkdayStretchType) {
    if (_.isNaN(value) || _.isNil(value)) value = 0

    debug && console.log(debug, 'process value', value)

    if (value === 0) {
        debug && console.log(debug, 'process to null')

        goal.startDate = null
        goal.endDate = null
        return
    }

    const hasDuration = !!goal.endDate

    let diff
    const startDate = goal.startDate ? goal.startDate : momentDate()
    const endDate = hasDuration ? goal.endDate : startDate

    switch (type) {
        case gd.const.workdayStretchTypes.EXCLUDE_HOLIDAYS:
            const workSchedule = goal.userId ? gd.workSchedule.getUserWorkSchedule(goal.userId) : gd.workSchedule.getCompanyWorkSchedule()

            const newEndDate = workSchedule.calculateEndDate(startDate, value)
            diff = newEndDate.diff(endDate, 'days')
            break

        default:
            let currentDuration = gd.utils.numberOfWeekdaysBetween(startDate, endDate)
            if (currentDuration < 1) currentDuration = 1

            diff = value - currentDuration
            break
    }

    goal.startDate  = startDate
    goal.endDate    = moment(endDate).add(diff, 'days') as MomentDate
}